<div class="post-types">
  <div class="post-type-card">
    <ly-icon icon="posts" size="16px"></ly-icon>
    <h5>Photos</h5>
    <p-radioButton
      [disabled]="disabled"
      name="post"
      value="post"
      (click)="changePostType()"
      [(ngModel)]="type"
    ></p-radioButton>
  </div>
  <div class="post-type-card">
    <ly-icon icon="reels"></ly-icon>
    <h5>Reel</h5>
    <p-radioButton
      [disabled]="disabled"
      name="reel"
      value="reel"
      (click)="changePostType()"
      [(ngModel)]="type"
    ></p-radioButton>
  </div>
  <div class="post-type-card">
    <ly-icon icon="stories"></ly-icon>
    <h5>Story</h5>
    <p-radioButton
      [disabled]="disabled"
      name="story"
      value="story"
      (click)="changePostType()"
      [(ngModel)]="type"
    ></p-radioButton>
  </div>
</div>
